var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path2, _rect17, _rect18, _rect19, _rect20, _rect21, _g, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path3, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _path4, _rect39, _rect40, _rect41, _rect42, _rect43, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.512,
    height: 42.507
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Card button"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5.13 22.825 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 100",
    width: 22.838,
    height: 31.884,
    rx: 11.419,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 101",
    width: 22.446,
    height: 31.337,
    rx: 11.223,
    transform: "translate(.196 .233)",
    fill: "#f9f9f9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 102",
    width: 22.054,
    height: 30.789,
    rx: 11.027,
    transform: "translate(.392 .466)",
    fill: "#f2f2f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 103",
    width: 21.662,
    height: 30.242,
    rx: 10.831,
    transform: "translate(.588 .699)",
    fill: "#ececec"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 104",
    width: 21.269,
    height: 29.694,
    rx: 10.635,
    transform: "translate(.785 .931)",
    fill: "#e5e5e5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 105",
    width: 20.877,
    height: 29.146,
    rx: 10.439,
    transform: "translate(.981 1.164)",
    fill: "#dfdfdf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 106",
    d: "M11.419 1.397a10.242 10.242 0 0110.243 10.242v8.114a10.242 10.242 0 01-10.243 10.244A10.242 10.242 0 011.177 19.753v-8.114A10.242 10.242 0 0111.419 1.397z",
    fill: "#d8d8d8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 107",
    width: 20.093,
    height: 28.051,
    rx: 10.046,
    transform: "translate(1.373 1.63)",
    fill: "#d2d2d2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 108",
    width: 19.7,
    height: 27.503,
    rx: 9.85,
    transform: "translate(1.569 1.863)",
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 109",
    width: 19.308,
    height: 26.956,
    rx: 9.654,
    transform: "translate(1.765 2.096)",
    fill: "#c5c5c5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 110",
    width: 18.916,
    height: 26.408,
    rx: 9.458,
    transform: "translate(1.961 2.328)",
    fill: "#bfbfbf"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 111",
    width: 18.524,
    height: 25.861,
    rx: 9.262,
    transform: "translate(2.157 2.561)",
    fill: "#b8b8b8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 112",
    width: 18.131,
    height: 25.313,
    rx: 9.066,
    transform: "translate(2.354 2.794)",
    fill: "#b2b2b2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 113",
    width: 17.739,
    height: 24.765,
    rx: 8.87,
    transform: "translate(2.55 3.027)",
    fill: "#ababab"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 114",
    width: 17.347,
    height: 24.218,
    rx: 8.673,
    transform: "translate(2.746 3.26)",
    fill: "#a5a5a5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 115",
    width: 16.954,
    height: 23.67,
    rx: 8.477,
    transform: "translate(2.942 3.493)",
    fill: "#9f9f9f"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 116",
    width: 16.562,
    height: 23.122,
    rx: 8.281,
    transform: "translate(3.138 3.725)",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 117",
    d: "M11.419 3.958a8.085 8.085 0 018.085 8.085v6.4a8.085 8.085 0 01-8.085 8.085 8.085 8.085 0 01-8.085-8.08v-6.4a8.085 8.085 0 018.085-8.09z",
    fill: "#929292"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 118",
    width: 15.778,
    height: 22.027,
    rx: 7.889,
    transform: "translate(3.53 4.191)",
    fill: "#8b8b8b"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 119",
    width: 15.385,
    height: 21.479,
    rx: 7.693,
    transform: "translate(3.727 4.424)",
    fill: "#858585"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 120",
    width: 14.993,
    height: 20.932,
    rx: 7.497,
    transform: "translate(3.923 4.657)",
    fill: "#7e7e7e"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 121",
    width: 14.601,
    height: 20.384,
    rx: 7.3,
    transform: "translate(4.119 4.89)",
    fill: "#787878"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 122",
    width: 19.859,
    height: 28.554,
    rx: 3,
    transform: "translate(1.49 .245)",
    fill: "#fcfcfc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M15.336 11.568a20.069 20.069 0 01-3.43-3.168.629.629 0 00-.975 0 20.077 20.077 0 01-3.429 3.168c-1.918 1.45-2.904 4.287-.972 5.984a3.068 3.068 0 004.265-.016 29.2 29.2 0 01-1.536 3c-.2.307-.112.409.236.3a6.561 6.561 0 011.924-.272 6.563 6.563 0 011.924.272c.348.108.433.006.236-.3a29.24 29.24 0 01-1.536-3 3.068 3.068 0 004.265.016c1.931-1.697.941-4.534-.972-5.984z",
    fill: "#050505"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 22447",
    width: 19.859,
    height: 28.554,
    rx: 3,
    transform: "translate(1.49 .245)",
    fill: "#7c7c7c",
    opacity: 0.602
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Card1",
    transform: "rotate(14 -18.94 49.25)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 100",
    width: 22.838,
    height: 31.884,
    rx: 11.419,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 101",
    width: 22.446,
    height: 31.337,
    rx: 11.223,
    transform: "translate(.196 .233)",
    fill: "#f9f9f9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 102",
    width: 22.054,
    height: 30.789,
    rx: 11.027,
    transform: "translate(.392 .466)",
    fill: "#f2f2f2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 103",
    width: 21.662,
    height: 30.242,
    rx: 10.831,
    transform: "translate(.588 .699)",
    fill: "#ececec"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 104",
    width: 21.269,
    height: 29.694,
    rx: 10.635,
    transform: "translate(.785 .931)",
    fill: "#e5e5e5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 105",
    width: 20.877,
    height: 29.146,
    rx: 10.439,
    transform: "translate(.981 1.164)",
    fill: "#dfdfdf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 106",
    d: "M11.419 1.397a10.242 10.242 0 0110.243 10.242v8.114a10.242 10.242 0 01-10.243 10.244A10.242 10.242 0 011.177 19.753v-8.114A10.242 10.242 0 0111.419 1.397z",
    fill: "#d8d8d8"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 107",
    width: 20.093,
    height: 28.051,
    rx: 10.046,
    transform: "translate(1.373 1.63)",
    fill: "#d2d2d2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 108",
    width: 19.7,
    height: 27.503,
    rx: 9.85,
    transform: "translate(1.569 1.863)",
    fill: "#ccc"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 109",
    width: 19.308,
    height: 26.956,
    rx: 9.654,
    transform: "translate(1.765 2.096)",
    fill: "#c5c5c5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 110",
    width: 18.916,
    height: 26.408,
    rx: 9.458,
    transform: "translate(1.961 2.328)",
    fill: "#bfbfbf"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 111",
    width: 18.524,
    height: 25.86,
    rx: 9.262,
    transform: "translate(2.157 2.561)",
    fill: "#b8b8b8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 112",
    width: 18.131,
    height: 25.313,
    rx: 9.066,
    transform: "translate(2.354 2.794)",
    fill: "#b2b2b2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 113",
    width: 17.739,
    height: 24.765,
    rx: 8.869,
    transform: "translate(2.55 3.027)",
    fill: "#ababab"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 114",
    width: 17.347,
    height: 24.218,
    rx: 8.673,
    transform: "translate(2.746 3.26)",
    fill: "#a5a5a5"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 115",
    width: 16.954,
    height: 23.67,
    rx: 8.477,
    transform: "translate(2.942 3.493)",
    fill: "#9f9f9f"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 116",
    width: 16.562,
    height: 23.122,
    rx: 8.281,
    transform: "translate(3.138 3.725)",
    fill: "#989898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 117",
    d: "M11.419 3.958a8.085 8.085 0 018.085 8.085v6.4a8.085 8.085 0 01-8.085 8.085 8.085 8.085 0 01-8.085-8.08v-6.4a8.085 8.085 0 018.085-8.09z",
    fill: "#929292"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 118",
    width: 15.778,
    height: 22.027,
    rx: 7.889,
    transform: "translate(3.53 4.191)",
    fill: "#8b8b8b"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 119",
    width: 15.385,
    height: 21.479,
    rx: 7.693,
    transform: "translate(3.727 4.424)",
    fill: "#858585"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 120",
    width: 14.993,
    height: 20.932,
    rx: 7.497,
    transform: "translate(3.923 4.657)",
    fill: "#7e7e7e"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 121",
    width: 14.601,
    height: 20.384,
    rx: 7.3,
    transform: "translate(4.119 4.89)",
    fill: "#787878"
  }))), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 122",
    width: 19.859,
    height: 28.554,
    rx: 3,
    transform: "translate(1.49 .245)",
    fill: "#fcfcfc",
    stroke: "#070309"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M15.336 11.568a20.069 20.069 0 01-3.43-3.168.629.629 0 00-.975 0 20.077 20.077 0 01-3.429 3.168c-1.918 1.45-2.904 4.287-.972 5.984a3.068 3.068 0 004.265-.016 29.2 29.2 0 01-1.536 3c-.2.307-.112.409.236.3a6.561 6.561 0 011.924-.272 6.563 6.563 0 011.924.272c.348.108.433.006.236-.3a29.24 29.24 0 01-1.536-3 3.068 3.068 0 004.265.016c1.931-1.697.941-4.534-.972-5.984z",
    fill: "#050505"
  }))))));
}
export default SvgCardButton;